/**
 * The three URLs of Documentation, in one place so a link from the release
 * page, a search row and a folder card cannot drift from the routes in
 * `App.tsx`. The section lived at `/knowledge-base/*` from 2026-09-14 to
 * 2026-09-17; those URLs, and the older `/documentation/type|library|…`
 * shapes, redirect here (`legacy-redirects.tsx`).
 *
 * (The `KB_` / `kb` names are code identifiers kept from that fortnight; no
 * person reads them.)
 */
export const KB_PATH = "/documentation";

/** A folder — the code's `category`. */
export function kbFolderPath(slug: string): string {
  return `${KB_PATH}/category/${encodeURIComponent(slug)}`;
}

/** An article — one document, whatever its `doc_type`. Declared AFTER the
 * folder route so "category" can never be read as an article slug. */
export function kbArticlePath(slug: string): string {
  return `${KB_PATH}/${encodeURIComponent(slug)}`;
}

/**
 * Documentation ▸ **Release documents** (2026-09-17): the pinned folder that
 * lists every release, and one release's versions with their documents.
 * Static segments, declared in `App.tsx` so they outrank `/documentation/:slug`
 * — an article whose slug is literally `releases` is shadowed, the same price
 * the legacy `search` redirect already pays.
 */
export const KB_RELEASES_PATH = `${KB_PATH}/releases`;

/** One release's page — the version picked rides as `?version=`. */
export function kbReleasePath(releaseVersion: string, version?: string): string {
  const base = `${KB_RELEASES_PATH}/${encodeURIComponent(releaseVersion)}`;
  return version ? `${base}?version=${encodeURIComponent(version)}` : base;
}
